import { ItemStateHandler } from "./ItemStateHandler";

const reducer = (actionPrefix, {initialState, editOnly, customReducer, cloneBeforeEdit, shallowClone} = {}) => {
	const handler = new ItemStateHandler({
		actionPrefix,
		initialState,
		editOnly,
		cloneBeforeEdit,
		shallowClone,
	});

	return {
		...handler.setupActions(),
		...customReducer,
	};
};

Object.defineProperty(reducer, "initialState", {value: ItemStateHandler.model.defaultInitialState});

export default reducer;